const getters = {
  mySubscription: (state) => state.mySubscription,
  myProperties: (state) => state.myProperties,
  myPropertiesMeta: (state) => state.myPropertiesMeta,
  adminSubscriptions: (state) => state.adminSubscriptions,
  adminSubscriptionsMeta: (state) => state.adminSubscriptionsMeta,
  hasActiveSubscription: (state) => state.mySubscription?.status === "active",
};

export default getters;
